import { DirectiveBase } from '../../angular-directive-base.directive';
import { SchemaFormCheckboxController } from './schema_form_checkbox.controller';

export class SchemaFormCheckbox extends DirectiveBase {

  constructor(private $filter) {
    super();
    this.require = ['ngModel'];
    this.bindToController = true;
    this.controller = SchemaFormCheckboxController;
    this.controllerAs = 'vm';
    this.restrict = 'A';
    this.scope = false;
    this.link = (scope, iElement, iAttrs, ngModelCtrl) => { this.linkFunction(scope, iElement, iAttrs, ngModelCtrl); };
  }

  private linkFunction(scope, iElement, iAttrs, ngModelCtrl) {
    scope.vm.ngModel = ngModelCtrl;
    scope.filter = this.$filter;
  }
}